<template>
  <div class="cont_body">
    <div class="list_cont">
      <!-- <div class="list_img">
        <img :src="getImg(optionsData.headImg)" alt="">
      </div> -->
      <div class="list_cont_body">
        <h4>{{optionsData.needName}}</h4>
        <h5>需求方：{{ optionsData.needUserName
        }}</h5>
        <div class="list_cont_mid">
          <!-- <p>投资额度：{{optionsData.investmentAmount}}万元</p> -->
          <p>需求类型：<dict-render :dict-obj="dictObjs['demand_type']"
            :text="optionsData.needType"></dict-render></p>
          <!-- <p>联系电话：{{optionsData.contactNumber}}</p>
          <p>投资地区：{{optionsData.investmentAddress}}</p> -->
        </div>
        <!-- <div class="list_cont_end">
          <a-tag v-for="(item,key) in optionsData.investmentField.split()" :key="key">
            <dict-render :dict-obj="dictObjs['investmentField']"
          :text="item"></dict-render>
          </a-tag>
        </div> -->
      </div>
      <div class="list_botton">
        <a-button size="large" @click="onAdd" style="width:120px;" >对接</a-button>
      </div>
    </div>
    <div class="list_bottom">
      <h4>需求介绍</h4>
      <p v-html="optionsData.needBody"></p>
    </div>
  </div>
  
</template>
<script>
import { dictMixin } from "@/mixins";
import {basicsNeedInfo} from "@/api/finance";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin],
  props: {
  },
  data() {
    return {
      dictNames: 'demand_type',
      optionsData:null,
      needId: null,
    }
  },
  created(){
    if(this.$route.query.queryData){
      this.getAction({
          url: basicsNeedInfo.detail,
          params: {
            id:this.$route.query.queryData
          }
      }).then(res => {
        this.optionsData = res
        this.needId = res.id

      })
    }
  },
	methods: {
    onAdd() {
            if(this.$ls.get('token')){
              this.visible=true;
              this.postAction({
                  url: basicsNeedInfo.drawNeed,
                  params: {
                    needId:this.needId
                  }
              }).then(res => {
                if(res){
                    this.$notification.success({
                                message: '对接成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                }
              })
            }else{
                    this.$notification.warning({
                                message: '登录后可以操作',
                                style: {
                                    fontWeight: '600',
                                },
                            });
              this.$router.push({ path: '/login', query: { id: 'user' } })
            }
    },
    handleOk(){
            this.visible = false;
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
:deep(.ant-tag){
  background: #e4e6fc;
  border-radius: 2px;
  border:none;
  padding:2px 10px;
}
.list_cont{
  width: 100%;
  padding:20px 0;
  margin-bottom: 16px;
  &:hover{
    cursor: auto!important;
    box-shadow: none!important;
  }
  .list_img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    margin-left:20px;
    flex: 6;
    h4{
      line-height: 50px;
    }
    .list_cont_mid{
      overflow: auto;
      padding-right:30%;
      color:#9c9c9c;
      p{
        display: block;
        float: left;
        width: 50%;
      }
    }
    .list_cont_end{
      margin-top: 20px;
      clear: both;
    }
  }
  .list_botton{
    flex: 1;
    :deep(.ant-btn){
      background: #1890ff;
      color:#fff
    }
  }
}
.list_bottom{
  h4{
    color:#1890ff;
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 10px;
  }
  p{
    line-height: 25px;
  }
}
</style>